import type { FC } from 'react';

import { PostCardSkeleton } from '../../PostCard/PostCardSkeleton';

export const FeedSkeleton: FC = () => (
  <div className="flex flex-col items-center w-full min-h-full">
    <div className="w-full max-w-[704px] flex flex-col gap-6 py-6 px-4 lg:px-0" aria-busy="true">
      <PostCardSkeleton />
      <PostCardSkeleton />
      <PostCardSkeleton />
    </div>
  </div>
);
